const isSelectedPackageSubscription = ({ selectedPaymentMethod }) => {
  return selectedPaymentMethod?.requiresSubscriptionId === true;
};

export default isSelectedPackageSubscription;
